import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import { RestLink } from 'apollo-link-rest';
import typePatcher from './rest-link/typePatcher';
import getEnvFromHostname from '../utils/getEnvFromHostname';
import getCurrentHostname from '../utils/getCurrentHostname';
import getGraphqlUrl from '../utils/getGraphqlUrl';
import errorLink from './utils/errorLink';
import localStore from '../lib/storage/localStore';
import { setContext } from '@apollo/client/link/context';

const envFromHostname = getEnvFromHostname();

if (envFromHostname === 'local') {
  loadDevMessages();
  loadErrorMessages();
}
const bffUri: string = getCurrentHostname();
const graphqlUri: string = getGraphqlUrl();

export const cache = new InMemoryCache({});

export const requestHeaderModifier = setContext(async (request, { headers }) => {
  const { operationName } = request;

  // Don't add client-uuid to searchEvents requests
  if (operationName === 'searchEvents') {
    return;
  }

  const clientUuid = await localStore.getItem('client-uuid');

  return {
    headers: {
      ...headers,
      'client-uuid': clientUuid,
    },
  };
});

export const buildGQLClient = (): ApolloClient<Record<string, unknown>> => {
  const httpLink = new HttpLink({
    credentials: 'include',
    headers: {
      'x-use-idp': 'true',
    },
    uri: graphqlUri,
  });

  const restLink = new RestLink({
    uri: bffUri,
    endpoints: {
      bff: bffUri,
      eventSearchApi:
        envFromHostname !== 'ue1live'
          ? 'https://search.ue1dev1.rostrr.net'
          : 'https://search.raceroster.com',
    },
    typePatcher,
    credentials: 'same-origin',
  });

  return new ApolloClient({
    link: from([errorLink, requestHeaderModifier, restLink, httpLink]),
    cache,
  });
};
